import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from '../../../util/withRouter';
import moment from 'moment';
import _ from 'lodash';

import { toggleAutorenewal, reactivateSubscription } from '../BillingActions';
import FormattedMessage from '../../../components/FormattedMessage';
import { getLocalePrice } from '../../../util/billingUtils';

// Import Style
import '../Billing.scss';

class DigitalAddOn extends Component {
  static defaultProps = {
    data: {},
    invoice: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      autorenewal: false,
    };

    this.switchRef = React.createRef();

    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleReactivate = this.handleReactivate.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        autorenewal: this.props.data.subscription.status === 'active',
      });
    }
  }

  handleSwitch() {
    this.setState({
      autorenewal: this.switchRef.current.checked,
    });
    this.props.toggleAutorenewal(this.switchRef.current.checked);
  }

  handleReactivate() {
    this.props.reactivateSubscription();
  }

  
  render() {
    const { app, reactivating, data, seats } = this.props;
    
    if (!data.subscription) {
      return <div></div>;
    }

    if (data.subscription.status == 'in_trial' ||
        data.subscription.status == 'paused' ||        
        data.subscription.status == 'future' ||
        data.subscription.status == 'cancelled') {
      return (
        <div className='white_box_details'>
          <span>No active subscription yet</span>
        </div>
      );
    }    
    else if (data.subscription.addons && data.subscription.addons.length > 0){
      return (
        <div className='white_box_details plan_info'>
          <h3>Digital Program Subscription</h3>
        
          <div className='plan_type'>
            <p>
              <span>Name:</span> {data.addon.name.replace(' Annual', '').replace(' New', '')}
            </p>
            {data.customer.card_status !== 'no_card' && (
              <Link to="/digital" reloadDocument>Change Addon</Link>
            )}
          </div>
          
          <p>
            <span>Subscription type:</span> {data.addon.period_unit === 'month' ? 'Monthly' : 'Annual'} subscription
          </p>
          <p>
            <span>
              Number of <FormattedMessage id={`seat`} mode="capitalize" plural="true" />:
            </span>{' '}
            {seats}{' '}
            {data.addon.meta_data && data.addon.meta_data.allowed > 0 ? `${data.addon.meta_data.allowed}` : ''}
          </p>  
          <p>
            <span>Total amount:</span> {getLocalePrice(data.subscription, data.addon.price / 100)}
          </p>
         
          {!!data.subscription.next_billing_at ? (
            <p>
              <span>Next billing date:</span> {moment.unix(data.subscription.next_billing_at).format('DD MMM YYYY')}
            </p>
          ) : (
            <p>
              <span>Cancellation date:</span> {moment.unix(data.subscription.current_term_end).format('DD MMM YYYY')}
            </p>
          )}
  
          {/* {data.subscription.status == 'active' && (
            <Confirm
              onConfirm={this.handleSwitch}
              title={'Turn off Auto-Renewal'}
              body={
                <p>
                  Your subscription will be cancelled on <br />
                  <b>{moment.unix(data.subscription.current_term_end).format('DD MMM YYYY')}</b>. Are you sure?
                </p>
              }
              confirmClass="btn-primary"
              confirmText="Confirm"
            >
              <div>
                <span>Auto-Renewal</span>
                <Switch
                  id="auto-renewal"
                  name="auto-renewal"
                  ref={this.switchRef}
                  checked={this.state.autorenewal}
                  readOnly
                />
              </div>
            </Confirm>
          )} */}
          {/* {data.subscription.status == 'non_renewing' && (
            <div>
              <span>Auto-Renewal</span>
              <Switch ref={this.switchRef} checked={this.state.autorenewal} onChange={this.handleSwitch} />
            </div>
          )}
          {data.subscription.status == 'cancelled' && (
            <div>
              <Button  onClick={this.handleReactivate}>
                {reactivating ? 'Loading...' : 'Reactivate subscription'}
              </Button>
            </div>
          )} */}
        </div>
      );
    }
    else if (data.subscription.status == 'active' ||
            data.subscription.status == 'non_renewing') {
      return (
        <div className='white_box_details addon'>
          <h3>The Nave Membership Experience</h3>        
          <p>
            Grab our bundle offer now! You can cancel anytime,
            and seats are transferable within your team. Act quickly,
            this deal expires on October 24th!
          </p>
          <div>
            <Link className="btn btn-primary" to="/digital">
              Book Your Seats
            </Link>
          </div>
        </div>
      );
    }
    else {
      return <div></div>;
    }

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    reactivateSubscription: () => dispatch(reactivateSubscription()),
    toggleAutorenewal: (val) => dispatch(toggleAutorenewal(val)),
  };
};

function mapStateToProps(state) {
  const dashboards = state.dashboards.list.length || state.auth.user.dashboards;
  return {
    app: state.app.app,
    dashboards,
    reactivating: state.billing.reactivating,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalAddOn));